export const MOBILE_VISIBLE_PLAYERS = 3;

export const visibleRoomPlayers = <T>(
  list: T[],
  compact: boolean,
  limit = MOBILE_VISIBLE_PLAYERS
) => ({
  visible: compact ? list.slice(0, limit) : list,
  remaining: compact ? Math.max(0, list.length - limit) : 0,
});
